<template>
  <div class="dropdown" :class="{ 'is-active': isActive }" :id="instanceName" v-mousedown-outside="closeDropDown">
    <div class="dropdown-trigger">
      <a v-if="!isPpaApprovalAction" @click.stop.prevent="onEntityClicked">{{ salesPerson.name }}</a>
      <span v-else class="tag is-info clickable" @click.stop.prevent="onEntityClicked">{{ salesPerson.name }}</span>
    </div>

    <div class="dropdown-menu">
      <div class="dropdown-content p-0">
        <div class="box has-background-grey-lighter" style="padding: 0.5rem; margin: 0;">
          <div class="columns is-mobile is-gapless is-vcentered" style="margin-bottom: 0.25rem;">
            <div class="column">
              <section-header title="Contact Details" :allowCollapse="false" />
            </div>
            <div class="column is-narrow has-text-right">
              <span class="delete close-btn" @click.stop.prevent="toggleDropdown" style="margin-right: 0.25rem;"></span>
            </div>
          </div>
          <div class="columns is-mobile is-gapless m-0">
            <div class="column">
              <div class="field mb-1">
                <label class="label is-small mb-0">Name</label>
                <div class="field is-size-7">
                  {{ salesPerson.name }}
                </div>
              </div>
              <div class="field mb-1">
                <label class="label is-small mb-0">Email</label>
                <div class="field is-size-7">
                  <a :href="buildEmailLink()" target="_blank">{{ salesPerson.email.toLowerCase() }}</a>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field mb-1">
                <label class="label is-small mb-0">Telephone</label>
                <div class="field is-size-7">
                  <click-to-call :whiteBackground="true" @click.native.stop :key="'ctc-' + salesPerson.receiverIdProp" :destinationLineProp="salesPerson.telephone" :receiverTypeProp="'User'" :receiverIdProp="salesPerson.receiverIdProp" />
                </div>
              </div>
              <div class="field mb-1">
                <label class="label is-small mb-0">Mobile</label>
                <div class="field is-size-7">
                  <click-to-call :whiteBackground="true" @click.native.stop :key="'ctc-2' + salesPerson.receiverIdProp" :destinationLineProp="salesPerson.mobile" :receiverTypeProp="'User'" :receiverIdProp="salesPerson.receiverIdProp" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field mb-1">
                <label class="label is-small mb-0">Ext</label>
                <div class="field is-size-7">
                  {{ salesPerson.ext }}
                </div>
              </div>
              <div class="field mb-1">
                <label class="label is-small mb-0">Tracking Number</label>
                <div class="field is-size-7">
                  {{ salesPerson.trackingNumber }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '@/eventBus'
import utilitiesMixin from '@/mixins/generic/utilities'
import SectionHeader from '@/components/generic/SectionHeader'
import ClickToCallComponent from '@/components/generic/ClickToCallComponent'

export default {
  name: 'ClickToContactInfoComponent',
  mixins: [utilitiesMixin],
  components: {
    'section-header': SectionHeader,
    'click-to-call': ClickToCallComponent
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    receiverTypeProp: {
      type: String,
      default: 'User'
    },
    usePortal: {
      type: Boolean,
      default: true
    },
    isPpaApprovalAction: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: false,
      instanceName: this.$uuid.v4(),
      salesPerson: this.value
    }
  },
  computed: {
  },
  methods: {
    closeDropDown () {
      if (!this.isActive) return
      this.isActive = false
      const parentWithClass = this.$el.closest('.vue-recycle-scroller__item-view')
      if (parentWithClass) parentWithClass.style.removeProperty('z-index')
    },
    toggleDropdown () {
      this.isActive = !this.isActive
      const parentWithClass = this.$el.closest('.vue-recycle-scroller__item-view')
      if (this.isActive) {
        eventBus.$emit('close-active-click-to-info', this.instanceName)
        if (parentWithClass) parentWithClass.style['z-index'] = 2

        this.$nextTick(() => {
          const dropdown = this.$el.querySelector('.dropdown-menu')
          const rect = dropdown.getBoundingClientRect()

          if (rect.bottom > window.innerHeight) {
            dropdown.style.top = 'auto'
            dropdown.style.bottom = '100%'
          } else {
            dropdown.style.top = '100%'
            dropdown.style.bottom = 'auto'
          }

          if (rect.right > window.innerWidth) {
            dropdown.style.left = 'auto'
            dropdown.style.right = '0'
          } else {
            dropdown.style.left = '0'
            dropdown.style.right = 'auto'
          }
        })
      } else {
        if (parentWithClass) parentWithClass.style.removeProperty('z-index')
      }
    },
    onCloseFromEmit (instanceToKeepAlive) {
      if (instanceToKeepAlive === this.instanceName) return
      this.closeDropDown()
    },
    onEntityClicked () {
      this.toggleDropdown()
    },
    buildEmailLink () {
      return 'mailto:' + this.salesPerson.email.toLowerCase()
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue) {
        this.salesPerson = newValue
      }
    }
  },
  mounted: function () {
    eventBus.$on('close-active-click-to-info', this.onCloseFromEmit)
  },
  beforeDestroy () {
    eventBus.$off('close-active-click-to-info', this.onCloseFromEmit)
  }
}
</script>

<style scoped>
  .dropdown-menu {
    z-index: 99999;
    min-width: 400px;
    background-color: transparent !important;
  }

  .dropdown-content {
    padding: 0 !important;
    margin: 0;
    background-color: transparent !important;
  }

  .box {
    padding: 0.5rem !important;
    margin: 0;
  }

  .label {
    font-size: 0.8rem;
    margin-bottom: 0 !important;
  }

  .field {
    margin-bottom: 0.25rem;
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .mb-1 {
    margin-bottom: 0.25rem !important;
  }

  .close-btn {
    margin: 0;
  }
</style>
